import * as types from '../constants/ActionTypes'
import { message } from 'antd';

let actionCreator = (retData) => {
    retData = JSON.parse(retData);
    if (retData.errCode === 0) {
        return {
            type: types.UPDATE_AGENT_PROFILE_FINISH,
            payload: retData.result
        }
    } else {
        return {
            type: types.UPDATE_AGENT_PROFILE_FINISH,
            payload: {},
            error: true
        }
    }
}

let updateAgentProfile = (formData) => {
    var url = '/api/updateAgentProfile'
    return dispatch => {
        var xhr = new XMLHttpRequest();
        xhr.open('put', url);
        xhr.onload = function () {
            if (xhr.status === 200) {
                var retData = xhr.responseText;
                if (JSON.parse(retData).errCode == 510) {
                    message.warning(JSON.parse(retData).errInfo)
                }
                return dispatch(actionCreator(retData));
            } else {
                return dispatch(actionCreator({ errCode: -1 }))
            }
        };
        xhr.send(formData);
    }

}



let clearResetHintMsg = () => {
    return dispatch => {
        return dispatch({
            type: types.CLEAR_RESET_HINT_MSG,
            payload: {}
        })
    }
}

export default {
    updateAgentProfile,
    clearResetHintMsg
}
